module.exports = __webpack_public_path__ + "img/edit.cbfe75f1.svg";